
export default function FeaturesSection() {
  const features = [
    {
      title: "Zero cash upfront",
      description: "RealRises pays for the bitcoin purchase, and closing costs are paid from the investment amount, so you pay nothing upfront."
    },
    {
      title: "No monthly payments, no interest",
      description: "It's an investment partnership, not a loan."
    },
    {
      title: "No margin calls",
      description: "No additional collateral is required, regardless of bitcoin or property value."
    },
    {
      title: "A decade to grow",
      description: "Designed by and for low time-preference bitcoiners."
    },
    {
      title: "No penalty to end early",
      description: "You're in control—end the BTIP any time for any reason without penalty."
    },
    {
      title: "Your property equity stays yours",
      description: "Your equity is used as collateral only if bitcoin's value has decreased at settlement and you can't cover the decrease. We don't share in your home appreciation."
    },
    {
      title: "No selling any assets",
      description: "Because RealRises provides all the capital to invest in bitcoin, you avoid asset sales that could disrupt your current investment strategy and trigger capital gains taxes."
    },
    {
      title: "No income nor credit check required",
      description: "Because, again, the RealRises BIP is a partnership, not a loan."
    }
  ];

  return (
    <section className="w-full">
      <div className="container mx-auto py-8 md:py-16 px-12">
        <div>
          <h2 className="text-center text-3xl md:text-5xl 2xl:text-6xl font-semibold tracking-tight text-blue-900">
            Key features
          </h2>
        </div>
        <p className="text-center text-xl md:text-3xl text-orange-500 max-w-3xl mx-auto md:mt-2 origin-center">
          Designed to be accessible to every bitcoiner & Tech Investor
        </p>
        
        <div className="mt-10 md:mt-20 prose dark:prose-invert max-w-none">
          <div className="flex flex-col gap-3 md:gap-8">
            {features.map((feature, index) => (
              <div key={index} className="grid grid-cols-1 md:grid-cols-5 items-start">
                <div className="flex md:col-span-2 items-start gap-2">
                  <div className="text-xl md:text-2xl 2xl:text-3xl font-bold pb-2">
                    {feature.title}
                  </div>
                </div>
                <div className="md:col-span-3 pl-8">
                  <p dangerouslySetInnerHTML={{ __html: feature.description.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
